module.exports = __webpack_public_path__ + "static/img/twjd-sde4.5bc793b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde4.png
// module id = 840
// module chunks = 0